"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.ValueTypeIterable = void 0;
const _imports_1 = require("../_imports");
// for normalizing a number or currency type to a percentage type in standard calculation
exports.ValueTypeIterable = [
    'currency',
    'number',
    'percentage',
];
// ============= ZOD SCHEMAS =============
// Value.ConfigSchema
exports.ConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('formula'),
    limit: _imports_1.z.string(),
    valueType: _imports_1.z.enum(exports.ValueTypeIterable),
});
//# sourceMappingURL=Value.js.map